module.exports = __webpack_public_path__ + "img/product_bg.972e87b4.png";